export interface IWatrPaymentError {
    id?:number,
    requestId: number,
    description: string,
    isResolved: boolean,
    createdDateTime?: Date,
    createdByUserId?: number,
    updatedDateTime?: Date,
    updatedByUserId?: number
}